import { useCallback, useMemo } from 'react';
import { atom, useAtom } from 'jotai';
import { useCurrentSimDataId } from './useCurrentSimDataId';
import { exclude } from '../../utils/array';

type UseSchemaComparison = {
  comparisons: string[];
  setComparisons: (newComparisons: string[]) => void;
  resetComparisons: () => void;
};

const comparisonsAtom = atom<string[]>([]);

const useSchemaComparison = (): UseSchemaComparison => {
  const [comparisons, setComparisons] = useAtom(comparisonsAtom);

  const { currentSimDataId } = useCurrentSimDataId();

  // データの切り替え時に自分自身が比較対象に含まれないようにする
  const filteredComparisons = useMemo((): string[] => {
    return exclude(comparisons, currentSimDataId);
  }, [comparisons, currentSimDataId]);

  const updateComparisons = useCallback(
    (newComparisons: string[]): void => {
      setComparisons(exclude(newComparisons, currentSimDataId));
    },
    [setComparisons, currentSimDataId]
  );

  const resetComparisons = useCallback((): void => {
    setComparisons([]);
  }, [setComparisons]);

  return {
    comparisons: filteredComparisons,
    setComparisons: updateComparisons,
    resetComparisons: resetComparisons,
  };
};

export { useSchemaComparison };
